<template>
  <div style="width:100%;background-color: white;" v-wechat-title="title">
    <div style="display: flex;justify-content: center;padding-top: 10%;">
      <img :src="require('../../resource/img/device/svg/logo.svg')" style="width: 100px;height: 100px;">
    </div>
    <div style="width: 100%;margin-top: 30px;display:flex;flex-direction: column;">
      <nut-textinput style="margin: 0 20px;" v-model="form.username" placeholder="请输入帐号/手机号码" :clearBtn="true"
                     :disabled="false"/>
      <nut-textinput @keydown.enter="login" style="margin: 10px 20px 0 20px;" v-model="form.password"
                     placeholder="请输入密码" type="password"
                     :clearBtn="true" :disabled="false"/>
<!--      <div style="text-align: right;color: #2d2d2d;margin: 10px 20px;font-size: 14px;">忘记密码?</div>-->
      <nut-button @click="login" style="margin: 20px;background: #1a87ff;border-radius: 5px;z-index: 10;">
        登录
      </nut-button>
    </div>
    <div
      style="position: fixed;color: #9B9B9B; font-size:12px;text-align: center;width: 100%;bottom: 0;height: 40px;line-height: 40px;">
      <span style="margin-right: 3px;">登录即代表阅读并同意</span><span style="color: #1a87ff;"
                                                              @click="service(0)">服务条款</span><span
      style="margin: 0 3px;">和</span><span style="color: #1a87ff;" @click="service(1)">隐私政策</span>
    </div>
  </div>
</template>

<script>
/**
 * 设备管理登录
 */
export default {
  name: 'DeviceLogin',
  data () {
    return {
      title : '圣菲机器人',
      form: {
        username: '',
        password: '',
        path: '/device/DeviceHome'
      }
    }
  },
  mounted () {
    this.$api.getUrl()
    let token = localStorage.getItem('token')
    if (token != '') {
      this.check()
    }
  },
  methods: {
    //验证登录状态
    check () {
      this.$api.post({
        url: '/device/api/device/device-account/find',
        data: {
          username: localStorage.getItem('username')
        }
      }).then(res => {
        localStorage.setItem('username', this.data.username)
        this.$api.user = res.data
        this.$router.replace('/device/DeviceHome')
      }).catch(err => {
        localStorage.removeItem('token')
        this.$toast.text('登录状态已过期')
      })
    },
    login () {
      if (this.form.username == '') {
        this.$toast.warn('请输入手机号码/帐号')
        return
      }
      this.form.loginType = 3
      if (this.form.password == '') {
        this.$toast.warn('请输入密码')
        return
      }
      this.$api.deviceLogin(this.form).then(res => {
        this.$router.replace(res.path)
      })
    },
    //服务协议
    service (type) {
      this.$router.push({
        path: '/device/ServiceAgreement',
        query: {
          type: type
        }
      })
    }
  }
}
</script>

<style scoped>
  >>> .nut-textinput input {
    border: none;
    border-bottom: 1px solid #dddfe6;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/DeviceLogin.vue